import { useEffect, useState } from "react";
import { toast } from "sonner";
import { FileSpreadsheet, Loader2 } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import { Button } from "../ui/button";

const monthLabel = (m) => new Date(`${m}-01T12:00:00`).toLocaleDateString("fr-FR", { month: "long", year: "numeric" });

/** Admin — export Excel des heures du mois (synthèse par salarié + détail) pour la paie. */
export function HoursExport() {
  const { axiosAuth } = useAuth();
  const api = axiosAuth();
  const current = new Date().toISOString().slice(0, 7);
  const [months, setMonths] = useState([current]);
  const [societes, setSocietes] = useState([]);
  const [month, setMonth] = useState(current);
  const [societeId, setSocieteId] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/tracking/admin/hours-months").then((r) => {
      setMonths(Array.from(new Set([current, ...(r.data.months || [])])).sort().reverse());
      setSocietes(r.data.societes || []);
    }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const download = async () => {
    setBusy(true);
    try {
      const params = new URLSearchParams({ month });
      if (societeId) params.set("societe_id", societeId);
      const r = await api.get(`/tracking/admin/hours-export.xlsx?${params}`, { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url; a.download = `heures-${month}${societeId ? `-${societeId}` : ""}.xlsx`; document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 10000);
      toast.success(`Export ${monthLabel(month)} téléchargé`);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Export impossible");
    } finally { setBusy(false); }
  };

  return (
    <div className="bg-[#14101c] border border-white/5 rounded-xl p-3 mb-6 flex items-center gap-2 flex-wrap" data-testid="hours-export">
      <FileSpreadsheet className="w-4 h-4 text-emerald-400 flex-shrink-0" />
      <div className="text-xs font-bold text-white">Export paie (Excel)</div>
      <select value={month} onChange={(e) => setMonth(e.target.value)} className="bg-[#0b0811] border border-white/10 rounded-lg text-xs text-white px-2 py-1.5 capitalize" data-testid="hours-export-month">
        {months.map((m) => <option key={m} value={m}>{monthLabel(m)}</option>)}
      </select>
      <select value={societeId} onChange={(e) => setSocieteId(e.target.value)} className="bg-[#0b0811] border border-white/10 rounded-lg text-xs text-white px-2 py-1.5" data-testid="hours-export-societe">
        <option value="">Toutes les sociétés</option>
        {societes.map((s) => <option key={s.societe_id} value={s.societe_id}>{s.name}</option>)}
      </select>
      <div className="flex-1" />
      <Button size="sm" onClick={download} disabled={busy} className="bg-emerald-500 hover:bg-emerald-600 text-white text-xs font-bold h-8" data-testid="hours-export-btn">
        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : "Télécharger le classeur"}
      </Button>
      <p className="w-full text-[10px] text-slate-500">Onglet « Synthèse » : heures validées / à valider / refusées et jours travaillés par salarié · Onglet « Détail » : chaque pointage (entrée, sortie, durée, source, statut, validateur). Les heures « à valider » ne sont pas comptées comme validées.</p>
    </div>
  );
}
